export default __webpack_public_path__ + "static/imgCosmetic-98aad22bfad9748a0dfef8249625ea40.webp";